import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import axios from 'axios';
import './BlogDetail.css';

const BlogDetail = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBlogDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogId]);

  const fetchBlogDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://madhusewingmachines.com/api/blogs/${blogId}`);
      if (response.data.success) {
        // Support either { data: {...} } or { blog: {...} }
        setBlog(response.data.data || response.data.blog);
      }
    } catch (err) {
      console.error('Error fetching blog:', err);
      setError('Failed to load blog post');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    } catch {
      return '';
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5" style={{ marginTop: '100px' }}>
        <Spinner animation="border" />
        <p className="mt-3">Loading blog post...</p>
      </Container>
    );
  }

  if (error || !blog) {
    return (
      <Container style={{ marginTop: '100px' }}>
        <Alert variant="danger">{error || 'Blog post not found'}</Alert>
        <Button variant="primary" onClick={() => navigate('/blog')}>
          Back to Blog
        </Button>
      </Container>
    );
  }

  return (
    <Container className="blog-detail-container" style={{ marginTop: '100px', marginBottom: '60px' }}>
      <button
        type="button"
        className="blog-back-btn mb-4"
        onClick={() => navigate('/blog')}
      >
        <span aria-hidden="true">←</span> Back to Blog
      </button>

      {blog.category && (
        <div className="mb-3">
          <Badge bg="info" className="blog-detail-category">
            {blog.category}
          </Badge>
        </div>
      )}

      <h1 className="blog-detail-title mb-3">{blog.title}</h1>

      <div className="blog-detail-meta mb-4">
        {blog.author && <span>By {blog.author}</span>}
        {blog.author && blog.createdAt && <span className="mx-2">•</span>}
        {blog.createdAt && <span>{formatDate(blog.createdAt)}</span>}
      </div>

      {blog.images && blog.images.length > 0 && (
        <img
          src={`https://madhusewingmachines.com/uploads/${blog.images[0].url}`}
          alt={blog.title}
          className="blog-detail-hero mb-4"
        />
      )}

      <div className="blog-detail-content">{blog.content}</div>

      {blog.tags && blog.tags.length > 0 && (
        <div className="mt-4">
          <h6 className="fw-bold">Tags:</h6>
          {blog.tags.map((tag, index) => (
            <Badge key={index} bg="secondary" className="me-2">
              {tag}
            </Badge>
          ))}
        </div>
      )}
    </Container>
  );
};

export default BlogDetail;
